import { defineStore } from 'pinia';

import { login } from "@/api";
import { Storage } from '@/utils/storage/index';


export const useUserStore = defineStore('user', {
    state: () => ({
        userInfo: {}
    }),
    actions: {
        async login(userInfo) {
            const res = await login({
                password: userInfo.password,
                account: userInfo.account,
                grantType: 'password',
                tenantId: '100000',
                type:'account',
                // grantType:'captcha',
            }, {
                'Captcha-Key': userInfo.key,
                'Captcha-Code': userInfo.code,
            });
            this.userInfo = res.data;
            let storage = Storage.getInstance();
            storage.set('USER_INFO', res.data,new Date()+1000*60*30)
            return res;
        },

    },
    getters: {
    },
});